import React from 'react';
export function Footer() {
  return <footer className="w-full bg-black border-t border-[#FFD700]/20 py-10 px-4" data-id="element-114">
      <div className="max-w-3xl mx-auto text-center" data-id="element-115">
        <div className="text-[#FFD700] text-2xl font-black tracking-widest mb-4" data-id="element-116">
          🎵 PROFEPACK
        </div>
        <p className="text-gray-400 text-sm leading-relaxed mb-4 max-w-xl mx-auto" data-id="element-117">
          El sistema de planificación musical N°1 para docentes de Música de
          primaria y secundaria en Argentina.
        </p>
        <p className="text-gray-500 text-sm italic mb-6" data-id="element-118">
          Porque enseñar Música no debería costarte todos los domingos del año.
        </p>
        <div className="h-px bg-[#FFD700]/20 mb-6" data-id="element-119" />
        <p className="text-gray-600 text-xs" data-id="element-120">
          © PROFEPACK — Todos los derechos reservados
        </p>
      </div>
    </footer>;
}